import { Stack } from '@mui/material';

const NoResultsOverlay = () => (
  <Stack height="100%" alignItems="center" justifyContent="center">
    조회된 데이터가 없습니다.
  </Stack>
);

export default NoResultsOverlay;
